import http from "./http-common";

class rpmService {
  queryString(payload) {
    return Object.keys(payload)
      .filter(
        (key) => key && payload[key] !== null && payload[key] !== undefined
      )
      .map((key) => `${key}=${payload[key]}`)
      .join("&");
  }

  rpmVitalRangeList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`VitalsRange/list/filter?${queryString}`);
  }

  rpmDevicesList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`Devices/list/filter?${queryString}`);
  }

  providerDetaisUpdate(payload) {
    return http.put(`/patient/providerUpdate/${payload.code}`, payload);
  }

  insuranceDetailsUpdate(payload) {
    return http.put(`/patient/programUpdate/${payload.code}`, payload);
  }

  newDeviceSave(payload) {
    return http.post("/Devices/", payload);
  }

  deviceActiveInactive(payload) {
    return http.put(`/Devices/${payload.id}`, payload);
  }

  devicePatientMapping(payload) {
    return http.post("/patientDevices/save", payload);
  }

  patientMappedDevicesList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`patientDevices/list/filter?${queryString}`);
  }

  rpmTasksList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/tasks/list/filter?${queryString}`);
  }

  rpmFrequenciesList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/frequency/list/filter?${queryString}`);
  }

  addNewTask(payload) {
    return http.post("/tasks/", payload);
  }

  addNewFrequency(payload) {
    return http.post("/frequency/", payload);
  }

  taskActiveInactive(payload) {
    return http.put(`/tasks/update/${payload.id}`, payload);
  }

  frequencyActiveInactive(payload) {
    return http.put(`/frequency/update/${payload.id}`, payload);
  }

  async AddMedication(data) {
    await http.post(`/PatientMedication/save/rpm`, data);
  }

  rpmAlertsList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/notification/list/filter?${queryString}`);
  }

  addNewAlert(payload) {
    return http.post("/notification/save", payload);
  }

  rpmReviewsList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/ReviewDetail/list/filter?${queryString}`);
  }

  addNewReview(payload) {
    return http.post("/ReviewDetail/", payload);
  }

  rpmCarePlanTaskList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patientTask/list/patient/task?${queryString}`);
  }

  rpmCarePlanDailyTaskList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/PatientCreatedTask/list?${queryString}`);
  }

  addCarePlanTask(payload) {
    return http.post("/patientTask/", payload);
  }

  updateCarePlanDailyTask(payload) {
    return http.post("/PatientCreatedTask/", payload);
  }

  userNotesToPatientList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/UserNotesToPatient/list?${queryString}`);
  }

  addNewNoteToPatient(payload) {
    return http.post("/UserNotesToPatient/", payload);
  }

  rpmCarePlanDailyMedList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/PatientCreatedMedication/list/filter?${queryString}`);
  }

  rpmCarePlanMedicationsList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/PatientMedication/list/filter?${queryString}`);
  }

  updateCarePlanDailyMedications(payload) {
    return http.post("/PatientCreatedMedication/save", payload);
  }

  rpmActivityReport(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patient/rpmActivityReport?${queryString}`);
  }

  rpmConfiguredVitalList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/PatientVitalsConfig/list/filter?${queryString}`);
  }

  updateRpmVital(payload) {
    return http.put(`/VitalsRange/${payload.id}`, payload);
  }

  savePatientClinicalStatus(payload) {
    return http.post("/PatientClinicalStatus/", payload);
  }

  updatePatientClinicalStatus(payload) {
    return http.put(`/PatientClinicalStatus/${payload.patientCode}`, payload);
  }

  rpmPatientClinicalStatus(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/PatientClinicalStatus/list?${queryString}`);
  }

  rpmCalenderActivity(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patient/getCalenderDetail?${queryString}`);
  }

  rpmPatientFilterCount(payload) {
    const queryString = this.queryString(payload);
    return http.get(
      `/PatientClinicalStatus/getClinicalStatusCountDetails?${queryString}`
    );
  }

  rpmLocationWiseChronicList(payload) {
    const queryString = this.queryString(payload);
    return http.get(
      `/patientChronicConditions/listPatientState-wise?${queryString}`
    );
  }
  rpmDashboardCompliance(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patientVitals/listDashboardCompliance?${queryString}`);
  }

  rpmAgeWiseChronicList(payload) {
    const queryString = this.queryString(payload);
    return http.get(
      `/patientChronicConditions/listAgeGroupPerc?${queryString}`
    );
  }

  fetchRpmDbCompliance(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patientVitals/listDashboardCompliance?${queryString}`);
  }
}

export default new rpmService();
